import { boot } from "quasar/wrappers";
import VueLogger from "vuejs3-logger";
import { ILoggerOptions } from "vuejs3-logger/dist/interfaces/logger-options";
import { LogLevels } from "vuejs3-logger/dist/enum/log-levels";

export default boot(({ app }) => {
  const isProduction = process.env.VUE_APP_ENV === "prod";

  const options: ILoggerOptions = {
    isEnabled: !isProduction,
    stringifyArguments: false,
    showLogLevel: true,
    showMethodName: true,
    separator: "|",
    showConsoleColors: true,
    logLevel: LogLevels.DEBUG,
  };

  app.use(VueLogger, options);
});
